import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-functionary',
  templateUrl: './functionary.component.html',
})
export class FunctionaryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
